module.exports = __webpack_public_path__ + "img/agents.7085d389.svg";